import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 获取极配汇左侧标准分组
export function getDictList(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/polarMatching/getDictList',
    method: 'get',
    params
  })
}
// 获取极配汇配件列表
export function findModelByType(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/polarMatching/findModelByType',
    method: 'post',
    data
  })
}
